import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { useParams, useHistory } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import RoleForm from '../RoleForm';
import Spinner from '../../util/Spinner';

const RoleInfo = () => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [role, setRole] = useState({ roleName: '', permissions: [] });
  const { orgRoleId: passedOrgRoleId } = useParams();
  useEffect(() => {
    const getRole = async () => {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/roles/${passedOrgRoleId}`,
      );
      const rolePerm = data.map(permission => permission.PermId);
      setRole({
        roleName: data[0].RoleName,
        permissions: rolePerm,
      });
    };
    const initialCalls = async () => {
      await Promise.all([getRole()]);
      setLoading(false);
    };
    initialCalls();
  }, []);

  const updateOrgRole = async (roleName, rolePermissions) => {
    try {
      await authStore.request.post(`${process.env.REACT_APP_API}/api/role`, {
        orgRoleId: passedOrgRoleId,
        roleName,
        permissions: rolePermissions,
      });
      history.push('/roles');
    } catch (e) {
      console.error(e);
    }
  };

  if (isLoading) return <Spinner />;

  return (
    <Observer
      render={() => {
        return (
          <RoleForm handleSubmission={updateOrgRole} initialValues={role} />
        );
      }}
    />
  );
};

export default RoleInfo;
